module.exports = __webpack_public_path__ + "static/img/jiahui4.a4257ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/jiahui4.png
// module id = ZMrO
// module chunks = 1